<template>
  <header
    class="w-full h-[4.2rem] flex flex-row-reverse items-center justify-between p-3 fixed top-0 bg-white border-b z-[110] dark:bg-neutral-800 dark:border-neutral-700"
  >
    <!-- Profile Image with Dropdown -->
    <div class="relative">
      <img
        src="@/assets/images/profile/user-1.jpg"
        alt="profile-pic"
        class="h-10 w-10 rounded-full cursor-pointer object-cover"
        @click.stop="toggleMenu"
      />

      <!-- Dropdown Menu -->
      <Transition name="dropdown">
        <div
          v-if="isMenuOpen"
          ref="menu"
          class="absolute right-[-220px] mt-2 w-64 bg-neutral-50 rounded-md shadow-lg py-1 z-50 dark:bg-neutral-700"
        >
          <div class="flex gap-2 py-4 px-2 border-b">
            <img
              src="@/assets/images/profile/user-1.jpg"
              alt="profile-pic"
              class="h-10 w-10 rounded-full object-cover"
            />
            <div class="flex flex-col gap-2">
              <p class="text-sm text-wrap">
                {{ user.name }}
                <span class="text-gray-500 text-xs"
                  >({{ user.marketing_code }})</span
                >
              </p>
              <p class="text-sm text-wrap">{{ user.email }}</p>
            </div>
          </div>

          <a
            href="#"
            class="flex mt-2 gap-2 p-2 text-gray-800 transition-colors hover:bg-blue-500 hover:text-white dark:text-gray-200 dark:hover:bg-blue-600"
            @click.prevent="handleOpenProfile"
          >
            <Icon icon="mdi:user" width="24" height="24" />
            پروفایل من
          </a>

          <a
            href="#"
            class="flex gap-2 p-2 text-gray-800 transition-colors hover:bg-red-500 hover:text-white dark:text-gray-200 dark:hover:bg-red-600"
            @click.prevent="menuAction('logout')"
          >
            <Icon icon="material-symbols:logout" width="24" height="24" />
            خروج
          </a>
        </div>
      </Transition>
    </div>

    <img
      src="@/assets/images/logos/directam-Logo1.png"
      alt="logo"
      class="h-full max-h-[3.5rem] desktop:hidden laptop:hidden"
    />
    <div class="flex gap-2 items-center">
      <Icon
        icon="material-symbols-light:menu"
        @click="toggleHamburgerMenu"
        class="text-icons rounded-full text-5xl cursor-pointer transition-colors p-2 hover:bg-icons-bg dark:hover:bg-neutral-700 dark:text-neutral-200"
      />
    </div>
  </header>
</template>

<script setup>
import { Icon } from "@iconify/vue";
import Swal from "sweetalert2";
import { ref, onMounted, onBeforeUnmount, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

const store = useStore();
const isMenuOpen = ref(false);
const menu = ref(null);
const router = useRouter();

const user = computed(() => store.state.userSlice.user);

// Toggle menu visibility
const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};

// Handle menu actions
const menuAction = (action) => {
  console.log("Menu action:", action);
  if (action === "logout") {
    handleLogout();
  }
  isMenuOpen.value = false;
};

// Close menu when clicking outside
const handleClickOutside = (event) => {
  if (
    menu.value &&
    !menu.value.contains(event.target) &&
    !event.target.closest('img[alt="profile-pic"]')
  ) {
    isMenuOpen.value = false;
  }
};

// Set up event listeners
onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", handleClickOutside);
});

const toggleHamburgerMenu = () => {
  store.commit("uiSlice/toggleHamburgerMenu");
};

const handleOpenProfile = () => {
  router.push("/profile");
  isMenuOpen.value = false; 
};

const handleLogout = () => {
  Swal.fire({
    title: "آیا مطمئن هستید؟",
    text: "برای خروج از سیستم تایید کنید.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "بله، خروج",
    cancelButtonText: "لغو",
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
  }).then((result) => {
    if (result.isConfirmed) {
      store.commit("userSlice/userLogout"); // Perform logout action
      router.push("/login"); // Redirect to login page
      Swal.fire("خروج با موفقیت انجام شد", "", "success"); // Success message
    }
  });
};
</script>

<style scoped>
.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.2s ease;
}

.dropdown-enter-from,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
